<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import QuestionsForm from '../components/questions-form'

  export default {
    template: '#questions-tab-template',
    name: 'QuestionsTab',
    components: {
      'questions-form': QuestionsForm,
    },
    props: {
      initQuestionsFormIndex: VueTypes.number.def(0),
    },
    data () {
      return {
        questionsFormIndex: this.initQuestionsFormIndex
      }
    },
    methods: {
      onFormChange (form) {
        window.app.onFormChange(form, this)
      },
    },
  }

</script>
